module.exports = __webpack_public_path__ + "img/TSY_01.4ee3c0c1.png";